export type PhoneValidationResult = "valid" | "invalid" | "skipped";

interface PhoneValidationApiResponse {
  status: PhoneValidationResult;
  reason?: string;
}

export async function validatePhoneNumber(
  digitsOnly: string,
  options: { country?: string; countryCallingCode?: string } = {}
): Promise<PhoneValidationResult> {
  if (typeof window === "undefined") {
    return "skipped";
  }

  const payload = {
    phone: digitsOnly,
    country: options.country,
    countryCallingCode: options.countryCallingCode,
  };

  try {
    const response = await fetch("/api/phone-validation", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    let data: PhoneValidationApiResponse | null = null;
    try {
      data = (await response.json()) as PhoneValidationApiResponse;
    } catch (_error) {
      data = null;
    }

    if (!data || typeof data.status !== "string") {
      return "skipped";
    }

    if (data.status === "valid" || data.status === "invalid" || data.status === "skipped") {
      return data.status;
    }

    return "skipped";
  } catch (_error) {
    return "skipped";
  }
}
